import React from 'react';
import ParkingBookingForm from './ParkingBookingForm';

const BlockModule = () => {
    return (
        <React.Fragment>
            <div className="component__parking-block">
                <h3>Airport Parking</h3>
                <ParkingBookingForm />
            </div>
        </React.Fragment>
    );
};

export default BlockModule;
